export function normalizeCarouselPhotoIndex({
  fallbackIndex,
  photoCount,
  visibleIndex,
}: {
  fallbackIndex: number;
  photoCount: number;
  visibleIndex: number;
}) {
  const candidate = Number.isFinite(visibleIndex)
    ? visibleIndex
    : fallbackIndex;

  if (!Number.isFinite(candidate) || photoCount <= 0) {
    return 0;
  }

  return Math.max(0, Math.min(photoCount - 1, Math.round(candidate)));
}
